import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { apiEndpointURL } from '../constants/endpoints-url';

@Injectable({
  providedIn: 'root'
})
export class QuickSearchService {
  httpClient = inject(HttpClient);

  getQuickSearchData(entityType: string, entityId: any, idType?: string, academicYear?: string) {
    const endpointUrl = [apiEndpointURL.quickSearchEndpoint, entityType, entityId].join('/');
    let params = new HttpParams();
    if (idType) params = params.set('legacyFlag', idType);
    if (academicYear) params = params.set('academicYear', academicYear);
    return this.httpClient.get(endpointUrl, { params });
  }
}